<template>
	<section :class="classes">
		<slot name="items" />
	</section>
</template>

<script setup lang="ts">
defineProps({
	classes: {
		type: String,
		default: '-mt-16 pb-24 lg:pb-16'
	}
})
</script>
